import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import './main.css'
import { App } from './App'
import '../app/globals.css'

import { ThemeProvider } from "./components/theme-provider"
import { initClarity } from './lib/clarity'
import { queryClient } from './queryClient'

// Tell Excalidraw to load font assets from our origin (vendored source)
window.EXCALIDRAW_ASSET_PATH = window.location.origin + "/";

initClarity()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
          <Toaster />
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
)
